import moment from 'moment';

moment.updateLocale('kk', {
  weekdaysMin: 'жс_дб_сс_ср_бс_жм_сб'.split('_')
});
